import { render, staticRenderFns } from "./Favorability.vue?vue&type=template&id=2964bba0&scoped=true"
import script from "./Favorability.vue?vue&type=script&lang=js"
export * from "./Favorability.vue?vue&type=script&lang=js"
import style0 from "./Favorability.vue?vue&type=style&index=0&id=2964bba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964bba0",
  null
  
)

export default component.exports